export default {
    MAX_LOGO_UNITS: 80,
    SPONSORS: 'Sponsors',
    ADD_SPONSOR_ICON: 'Add Sponsor Icon',
    UPDATE_SPONSOR_ICON: 'Update Sponsor Icon',
    DELETE_SPONSOR_ICON: 'Delete',
    SPONSOR_LOGO: 'Sponsor logo: ',
    LINK_LOGO: 'Link logo to: ',
    SURE_TO_DELETE: 'Are you sure you want to delete this item?',
    CANCEL: 'CANCEL',
    ADD: 'ADD',
    APPLY: 'APPLY',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    MANAGE_SPONSORS: 'Manage Sponsors',
    ADD_BUTTON_LIMIT: 'Cannot add more sponsors.',
    NO_SPONSORS: 'No sponsors listed.',
    manageSponsorMode: {
        add: 'add',
        edit: 'edit',
        delete: 'delete',
    },
};
